import { fetchBudgetHistory, fetchManager, fetchMe } from '../../../api/user'

// initial state
const state = {
  me: null,
  manager: '',
  budgetHistory: []
}

// getters
const getters = {
  me: state => state.me,
  manager: state => state.manager,
  budgetHistory: state => state.budgetHistory
}

// actions
const actions = {
  async fetchMe ({commit}) {
    const me = await fetchMe()
    if (me.PERSONAL_BIRTHDAY === null) {
      me.PERSONAL_BIRTHDAY = new Date()
    }
    commit('setMe', {me})
  },
  async fetchManager ({commit}) {
    let manager = await fetchManager()
    commit('setManager', {manager: manager.manager})
  },
  async fetchBudgetHistory ({commit}) {
    let budgetHistory = await fetchBudgetHistory()
    commit('setBudgetHistory', {budgetHistory})
  }
}

// mutations
const mutations = {
  setMe (state, {me}) {
    state.me = me
  },
  setManager (state, {manager}) {
    state.manager = manager
  },
  setBudgetHistory (state, {budgetHistory}) {
    state.budgetHistory = budgetHistory
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/user.js